import axios from 'axios'
// import AWS from 'aws-sdk'

// const S3 = new AWS.S3({ signatureVersion: 'v4' })

export const getImageMeta = async (
    url: string
): Promise<{
    width: number
    height: number
    size: any
    type: string
    localUrl: string
}> => {
    if (!url) return { width: 0, height: 0, type: '', size: 0, localUrl: '' }
    const img = new Image()
    img.src = url
    const file = img.src
    // const fileExtension = file.split('.').pop()
    // const localUrl = URL.createObjectURL(file)
    // reading a file to get height and width
    async function getImageParams(file: Blob) {
        return new Promise((resolve, _reject) => {
            var reader = new FileReader()
            reader.onload = async (e: any) => {
                var image = new Image()
                image.src = e.target.result
                await image.decode()
                resolve({ width: image.width, height: image.height, fileExtension: file.type })
            }
            reader.readAsDataURL(file)
        })
    }
    const blob: Blob | null = await fetch(url).then(r => r.blob()).catch(_ => null)
    if (!blob) return { width: 0, height: 0, size: 4, type: "", localUrl: file }
    const imageData = await getImageParams(blob)
    console.log(blob)
    console.log(imageData)
    const { width, height, fileExtension } = imageData as any
    // return { width:0, height: 0, fileSize: 4, fileExtension: "", localUrl: file }
    return { width, height, type: fileExtension, size: (blob?.size / 1000).toFixed(2), localUrl: file }
}

// export const validateImg = (file: File) => {
//     const maxAllowedSize = 250000
//     const isImage = file.type.split('/')[0] === 'image'
//     if (!isImage) throw new Error(`Only image file is allowed, e.g .png, .jpg, .jpeg or .gif`)
//     if (file.size > maxAllowedSize) throw new Error(`Image size should not exceed ${maxAllowedSize / 1000} KB`)
//     return true
// }

export const validateImg = (file: File) => {
    const allowedExtensions = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'svg+xml'];
    const fileType = file.type.split('/')[1];
    if (!allowedExtensions.includes(fileType)) {
        throw new Error(`Only image or SVG files are allowed, e.g., .png, .jpg, .jpeg, .gif, .svg`);
    }
    return true;
};


export const getImageURLForLocalFiles = (file: any) => window.URL.createObjectURL(file)

export const checkUrl = async (url: string) => {
    try {
        await axios.head(url)
        return true
    } catch (error: any) {
        if (error.response.status >= 400) {
            throw ('Not a Valid Image Url')
        }
    }
}



export const getUrl = async (file: any, imageUrl: string = '') => {
    let url = ''
    try {
        if (file) {
            validateImg(file)
            url = getImageURLForLocalFiles(file)
        }
        // else if (imageUrl?.includes('https://fortunecms-assets.s3.amazonaws.com')) {
        //     return
        // }
        else if (imageUrl && await checkUrl(imageUrl)) url = imageUrl
        return url
    }
    catch (err: any) { throw new Error(err) }
}

export const getFaviconUrl = async (file: any) => {
    try {
        if (file) {
            const maxAllowedSize = 1000000; // 1 MB (1 million bytes)
            const isPngOrJpeg = /^image\/(png|jpeg)$/.test(file.type);

            if (!isPngOrJpeg) throw new Error(`Only PNG and JPEG image files are allowed.`);

            // First compress the image to reduce size
            const fileUrl = URL.createObjectURL(file);
            const compressedFile = await compressImage(fileUrl, 500); // 800KB target

            return new Promise<string>((resolve, reject) => {
                const image = new Image();

                image.onload = () => {
                    const width = image.width;
                    const height = image.height;

                    if (width < 32 || height < 32) {
                        reject(`Image size should be at least 32x32 pixels.`);
                    } else if (compressedFile.size > maxAllowedSize) {
                        reject(`Image size should not exceed ${maxAllowedSize / 1000} KB`);
                    } else {
                        const imageUrl = getImageURLForLocalFiles(compressedFile);
                        resolve(imageUrl);
                    }
                };

                image.onerror = () => {
                    reject(`Failed to load the image.`);
                };

                image.src = fileUrl;
            });
        }
        return '';
    } catch (err: any) {
        throw new Error(err);
    }
};


export const compressImage = async (base64: string, maxSizeKB = 250): Promise<File> => {
    const img = new Image();
    img.src = base64;

    await new Promise((resolve) => {
        img.onload = resolve;
    });

    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error("Canvas context not available");

    ctx.drawImage(img, 0, 0);

    let quality = 0.9;
    let blob: Blob | null = null;

    // Try reducing quality until under size
    do {
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
        blob = await (await fetch(compressedBase64)).blob();
        if (blob.size / 1024 <= maxSizeKB) break;
        quality -= 0.1;
    } while (quality > 0.1);

    return new File([blob], `compressed-${Date.now()}.jpg`, { type: 'image/jpeg' });
};

// export const putImageInS3 = async (file: any, id: string, url: string, bucket: string) => {
//     // const key = `${id}/${width}*${height}`
//     const key = id
//     const urlBuffer = (url: string) => axios.get(encodeURI(url), { responseType: 'arraybuffer' }).then(res => res.data)
//     const buffer = file ? await file.arrayBuffer() : await urlBuffer(url)
//     try {
//         // await checkUrl(`https://fortunecms-assets.s3.amazonaws.com/${key}`)
//         await S3.putObject({
//             Body: buffer,
//             Bucket: bucket,
//             Key: key,
//             ContentType: 'image/jpeg',
//             ContentDisposition: 'inline' // display images inline
//         }).promise()
//         return { imageUrl: `https://${bucket}.s3.amazonaws.com/${key}` }
//     } catch (err) {
//         console.log(err)
//         return { imageUrl: '' }
//     }
// }

// export const deleteImageFromS3 = async (bucket: string, id: string) => {
//     try {
//         await S3.deleteObject({ Bucket: bucket, Key: id }).promise()
//         return true
//     } catch (err) {
//         console.log(err)
//     }
// }

// export async function emptyS3Directory(bucket: string, dir: string) {
//     const listParams = {
//         Bucket: bucket,
//         Prefix: dir
//     }

//     const listedObjects: any = await S3.listObjectsV2(listParams).promise()

//     if (listedObjects.Contents.length === 0) return

//     const deleteParams: any = {
//         Bucket: bucket,
//         Delete: { Objects: [] }
//     }

//     listedObjects.Contents.forEach(({ Key }: any) => { deleteParams.Delete.Objects.push({ Key }) })

//     await S3.deleteObjects(deleteParams).promise()

//     if (listedObjects.IsTruncated) await emptyS3Directory(bucket, dir)
// }

export function getImageHeight(url: string) {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject();
        img.src = url;
        resolve({ height: img.height })
    });
}

export const getIconSvgPath = (iconName: string, weight: string = 'regular'): string => {
    try {
        const svgPath = require(`@phosphor-icons/core/assets/${weight}/${iconName}${weight !== 'regular' ? `-${weight}` : ''}.svg`);
        return svgPath.default || svgPath;
    } catch (err) {
        console.error(`Failed to load icon: ${iconName}`, err);
        return '';
    }
};
